import React from 'react';

import PropTypes from 'prop-types';

import { Logo } from '~/techstyle-shared/react-builder-models';
import {
  FableticsLogo,
  FableticsMarkLogo,
  SavageLogo,
  SavageMarkLogo,
  useBreakpoint,
} from '~/techstyle-shared/react-components';

const PreloadedLogo = ({ type }) => {
  const { isMobile } = useBreakpoint();

  switch (type) {
    case Logo.TYPES.DEFAULT_MARK_LOGO_FL:
      return <FableticsMarkLogo width={41} />;
    case Logo.TYPES.DEFAULT_FULL_LOGO_FL:
      return <FableticsLogo width={135} />;
    case Logo.TYPES.DEFAULT_MARK_LOGO_SXF:
      return <SavageMarkLogo width={41} />;
    case Logo.TYPES.DEFAULT_FULL_LOGO_SXF:
      return <SavageLogo width={isMobile ? 180 : '100%'} />;
    default:
      return null;
  }
};

PreloadedLogo.propTypes = {
  type: PropTypes.string,
};

export default PreloadedLogo;
